var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-full flex flex-col gap-5",
      attrs: { id: "package-usage-history" }
    },
    [
      _c("div", { staticClass: "flex flex-col bg-pure-white rounded-2xl" }, [
        _c(
          "div",
          {
            staticClass:
              "sticky top-30 z-30 py-4 px-6 flex items-center justify-between bg-pure-white rounded-t-2xl"
          },
          [
            _c("BlTextTitle4", { attrs: { text: "Usage history" } }),
            _vm._v(" "),
            _c("BlSort", {
              staticClass: "w-60",
              attrs: {
                options: _vm.sortOptions,
                defaultValue: _vm.defaultSort
              },
              on: {
                change: function($event) {
                  return _vm.onChangeSort($event)
                }
              },
              model: {
                value: _vm.sortInput,
                callback: function($$v) {
                  _vm.sortInput = $$v
                },
                expression: "sortInput"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-col items-center" }, [
          _vm.fetchLoading
            ? _c("div", { staticClass: "h-128 grid place-items-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : !_vm.transactions.length
            ? _c(
                "div",
                {
                  staticClass:
                    "px-6 h-128 flex flex-col items-center justify-center"
                },
                [
                  _c("BlTextBody1", {
                    staticClass: "text-center",
                    attrs: {
                      text:
                        "This package hasn't been used in any appointments yet. Once it's assigned, the usage history will be displayed here."
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "mb-8" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky top-48 z-20 flex items-center flex-grow rounded-t",
                      attrs: { id: "package-usage-history-header" }
                    },
                    [
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "w-25 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 rounded-tl border-l",
                          scopedSlots: _vm._u([
                            {
                              key: "tooltip",
                              fn: function() {
                                return [
                                  _c("div", { staticClass: "w-25" }, [
                                    _vm._v("Transaction ID")
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Transaction ID" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "w-40 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Transaction date" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "w-40 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Client name" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "w-40 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Added by" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-25 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 rounded-tr border-r"
                        },
                        [_c("BlTextSubtitle3", { attrs: { text: "" } })],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.transactions, function(transaction, idx) {
                    return _c(
                      "div",
                      { key: transaction.id, staticClass: "flex h-13" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-25 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400 border-l",
                            class: {
                              "rounded-bl": idx + 1 === _vm.transactions.length
                            }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: {
                                title: transaction.id,
                                text: transaction.id
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-40 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: {
                                text: _vm.displayDate({
                                  date: transaction.created_at,
                                  format: "DD MMM YYYY HH:mm",
                                  empty: ""
                                })
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-40 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
                          },
                          [
                            !transaction.client
                              ? _c("BlTextBody2", { attrs: { text: "-" } })
                              : _c("BlTextBody2", {
                                  staticClass: "truncate",
                                  attrs: {
                                    title: transaction.client.name,
                                    text: transaction.client.name
                                  }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-40 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
                          },
                          [
                            !transaction.user
                              ? _c("BlTextBody2", { attrs: { text: "-" } })
                              : _c("BlTextBody2", {
                                  staticClass: "truncate",
                                  class: { " italic": !transaction.user.name },
                                  attrs: {
                                    title:
                                      transaction.user.name || "Deleted user",
                                    text:
                                      transaction.user.name || "Deleted user"
                                  }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-25 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400 border-r",
                            class: {
                              "rounded-br": idx + 1 === _vm.transactions.length
                            }
                          },
                          [
                            transaction.client
                              ? _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "ClientTab",
                                        params: {
                                          id: transaction.client.id,
                                          tab: "credit",
                                          redirect_target:
                                            "/center/package/" +
                                            _vm.$route.params.id +
                                            "/history",
                                          redirect_label:
                                            "Package usage history"
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _c("BlInputButton", {
                                      attrs: {
                                        label: "View client",
                                        type: "outlined",
                                        dense: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              ),
          _vm._v(" "),
          _vm.totalTransactions > 25
            ? _c(
                "div",
                { staticClass: "px-6 w-full mb-36" },
                [
                  _c("BlInputPagination", {
                    attrs: {
                      page: _vm.page,
                      perPage: _vm.perPage,
                      total: _vm.totalTransactions
                    },
                    on: {
                      changed: _vm.changePage,
                      "changed-per-page": _vm.changePerPage
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ab13ff4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab13ff4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/package/PackageUsageHistory.vue
// module id = null
// module chunks = 